import './oct-globalnav.scss'

const prefix = 'oct-globalnav'

class OCTGlobalnav {
  constructor (el) {
    if (el.__OCTGlobalnav) return this

    this.el = el
    this.previosScrollTop = 0

    window.addEventListener('scroll', () => this.scrollHandler())

    this.el.__OCTGlobalnav = this
  }

  scrollHandler () {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop

    if (currentScrollTop > 0) {
      if (this.previosScrollTop > currentScrollTop)
        this.el.classList.remove(prefix + '--sticking-up')
      else {
        this.el.classList.add(prefix + '--sticking-up')
        this.el.clientHeight // force reflow
      }

      this.el.classList.add(prefix + '--sticking')
    } else {
      this.el.classList.remove(prefix + '--sticking')
      this.el.classList.remove(prefix + '--sticking-up')
    }

    this.previosScrollTop = currentScrollTop
  }
}

document.addEventListener('DOMContentLoaded', event => { // eslint-disable-line no-unused-vars
  Array.from(document.querySelectorAll('.oct-globalnav')).forEach(el => new OCTGlobalnav(el))

  process.env.NODE_ENV === 'development' && console.info('[OCT] Intializing OCTGlobalnav...')
})

export default OCTGlobalnav